import React from 'react';
import { SuggestComboBoxProps } from '../ComboBox/AbstractComboBox/SuggestComboBox';
import { TopUserResult } from '../ComboBox';
import { SelectParam, CategoriesParam } from '../../../../../_lib/Form2';
import { UserWithRolesSelectSingleRole } from './UserWithRolesSelectSingleRole';
import { UserWithRolesSelectMultiRole } from './UserWithRolesSelectMultiRole';

type RoleParamSingle = SelectParam<'roleId'>;
type RoleParamMulti = CategoriesParam<'roles'>;

export type UserWithRolesSelectProps = {
  idPrefix: string;
  roleParam: RoleParamSingle | RoleParamMulti;
} & Omit<SuggestComboBoxProps<TopUserResult>, 'id' | 'onSelection' | 'validationMessage'>;

export function UserWithRolesSelect({ idPrefix, roleParam, ...rest }: UserWithRolesSelectProps) {
  if (roleParam.name === 'roles') {
    return <UserWithRolesSelectMultiRole idPrefix={idPrefix} roleParam={roleParam} suggestComboBoxProps={rest} />;
  }

  if (roleParam.name === 'roleId') {
    return <UserWithRolesSelectSingleRole idPrefix={idPrefix} roleParam={roleParam} suggestComboBoxProps={rest} />;
  }

  return null;
}
